// extracted by mini-css-extract-plugin
module.exports = {"widget":"styles_widget__gTh_T","widget__wrapper":"styles_widget__wrapper__FKUBJ","pulse":"styles_pulse__xdarz","jump":"styles_jump__zta_o"};